import styled from 'styled-components';
import React, { Fragment, RefObject, useEffect, useState } from 'react';

import useDevice from '@hooks/useDevice';
import { onLogoClick, scrollToPath } from '@utils/scrollTo';
import Logo from '@public/icons/logo_mobile.svg';
import { HamburgerMenu } from '@components/atoms';
import FullLogo from '@public/icons/logo_full.svg';
import { Navigate, Social } from '@components/molecules';
import { socialNavigation } from '@shared/constants/navigate';
import { useIsClient } from '@hooks/useIsClient';

type HeaderMobileProps = {
  refs: RefObject<HTMLDivElement>[];
};

function HeaderMobile({ refs }: HeaderMobileProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [pathname, setPathname] = useState('');
  const isClient = useIsClient();
  const { isMobile } = useDevice();

  const toggleOpen = () => setIsOpen(!isOpen);
  const onLinkClick = (e: React.MouseEvent<HTMLElement>) => {
    scrollToPath(e, pathname, refs);
  };

  useEffect(() => {
    if (isClient) {
      const path = window.location.pathname.replace('/', '');

      setPathname(path);
    }
  }, [isClient]);

  return (
    <Fragment>
      <Wrapper>
        <IconWrapper $width="60%">
          {isMobile ? (
            <Logo onClick={onLogoClick} />
          ) : (
            <FullLogo onClick={onLogoClick} style={{ cursor: 'pointer' }} />
          )}
        </IconWrapper>

        <IconWrapper $width="40%">
          <HamburgerMenu isOpen={isOpen} toggleOpen={toggleOpen} />
        </IconWrapper>
      </Wrapper>

      <MenuContent $isOpen={isOpen} $isMobile={isMobile}>
        <Content>
          <Navigate
            ariaLabel="Site navigation"
            onLinkClick={onLinkClick}
            direction="column"
          />

          <Social
            ariaLabel="Contact and social links"
            links={socialNavigation}
          />
        </Content>
      </MenuContent>
    </Fragment>
  );
}

const MenuContent = styled.div<{ $isOpen: boolean; $isMobile: boolean }>`
  width: 100%;
  position: fixed;
  transition: 0.3s ease;
  overflow: hidden;

  left: 0;
  top: ${({ $isMobile }) => ($isMobile ? '66px' : '98px')};

  height: ${({ $isOpen }) => ($isOpen ? '230px' : '0')};
  background-color: ${({ theme }) => theme.colors.athensGray};

  border-bottom-right-radius: 12px;
  border-bottom-left-radius: 12px;

  box-shadow: 0 2px 2px #80808059;
`;

const Wrapper = styled.div`
  height: 100%;
  width: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const IconWrapper = styled.div<{ $width: string }>`
  width: ${({ $width }) => $width};

  display: flex;
  justify-content: flex-start;
  align-items: center;

  &:last-child {
    justify-content: flex-end;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  height: 100%;
`;

export default HeaderMobile;
